<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment">

        <form class="ui form">
          <div class="fields">
            <div class="two wide field">
              <label class="form-label">Código</label>
              <span v-if="isObject(customer.code)">Antes: {{ customer.code.__old + '-' + isObject(customer.unit) ? customer.unit.__old : customer.unit }}</span>
              <p v-if="isObject(customer.code)"></p>
              <span>{{ [isObject(customer.code) ? customer.code.__new : customer.code] + '-' + [isObject(customer.unit) ? customer.unit.__new : customer.unit] }}</span>
            </div>
            <div class="six wide field">
              <label class="form-label">Razão Social</label>
              <span v-if="isObject(customer.name)">Antes: {{ customer.name.__old }}</span>
              <p v-if="isObject(customer.name)"></p>
              <span>{{ isObject(customer.name) ? customer.name.__new : customer.name }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">CNPJ</label>
              <span v-if="isObject(customer.formatCnpj)">Antes: {{ customer.formatCnpj.__old }}</span>
              <p v-if="isObject(customer.formatCnpj)"></p>
              <span>{{ isObject(customer.formatCnpj) ? customer.formatCnpj.__new : customer.formatCnpj }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Inscrição Estadual</label>
              <span v-if="isObject(customer.ie)">Antes: {{ customer.ie.__old }}</span>
              <p v-if="isObject(customer.ie)"></p>
              <span>{{ isObject(customer.ie) ? customer.ie.__new : customer.ie }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Endereço</label>
              <span v-if="isObject(customerAddress)">Antes: {{ customerAddress.__old }}</span>
              <p v-if="isObject(customerAddress)"></p>
              <span>{{ isObject(customerAddress) ? customerAddress.__new : customerAddress }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Telefone</label>
              <span v-if="isObject(customer.ddd)">Antes: {{ customer.ddd.__old + ' ' + isObject(customer.phone) ? customer.phone.__old : customer.phone }}</span>
              <p v-if="isObject(customer.ddd)"></p>
              <span>{{ [isObject(customer.ddd) ? customer.ddd.__new : customer.ddd] + ' ' + [isObject(customer.phone) ? customer.phone.__new : customer.phone] }}</span>
            </div>
            <div class="five wide field">
              <label class="form-label">E-mail</label>
              <span v-if="isObject(customer.email)">Antes: {{ customer.email.__old }}</span>
              <p v-if="isObject(customer.email)"></p>
              <span>{{ isObject(customer.email) ? customer.email.__new : customer.email }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">CNAE</label>
              <span v-if="isObject(customer.cnae)">Antes: {{ customer.cnae.__old }}</span>
              <p v-if="isObject(customer.cnae)"></p>
              <span>{{ isObject(customer.cnae) ? customer.cnae.__new : customer.cnae }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Pessoa</label>
              <span v-if="isObject(customer.person)">Antes: {{ customer.person.__old }}</span>
              <p v-if="isObject(customer.person)"></p>
              <span>{{ isObject(customer.person) ? customer.person.__new : customer.person }}</span>
            </div>           
            <div class="five wide field">
              <label class="form-label">Segmento</label>
              <span v-if="isObject(customer.segment)">Antes: {{ customer.segment.__old }}</span>
              <p v-if="isObject(customer.segment)"></p>
              <span>{{ isObject(customer.segment) ? customer.segment.__new : customer.segment }}</span>
            </div>             
          </div>
          <div class="fields">
            <div class="two wide field">
              <label class="form-label">Contribuinte</label>
              <span v-if="isObject(customer.taxPayer)">Antes: {{ customer.taxPayer.__old }}</span>
              <p v-if="isObject(customer.taxPayer)"></p>
              <span>{{ isObject(customer.taxPayer) ? customer.taxPayer.__new : customer.taxPayer }}</span>
            </div>    
            <div class="three wide field">
              <label class="form-label">Tipo</label>
              <span v-if="isObject(customer.type)">Antes: {{ customer.type.__old }}</span>
              <p v-if="isObject(customer.type)"></p>
              <span>{{ isObject(customer.type) ? customer.type.__new : customer.type }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Opt. Simples Nacional</label>
              <span v-if="isObject(customer.nationalSimple)">Antes: {{ customer.nationalSimple.__old }}</span>
              <p v-if="isObject(customer.nationalSimple)"></p>
              <span>{{ isObject(customer.nationalSimple) ? customer.nationalSimple.__new : customer.nationalSimple }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Desconto SUFRAMA</label>
              <span v-if="isObject(customer.suframa)">Antes: {{ customer.suframa.__old }}</span>
              <p v-if="isObject(customer.suframa)"></p>
              <span>{{ isObject(customer.suframa) ? customer.suframa.__new : customer.suframa }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Reg. Esp. Tributação</label>
              <span v-if="isObject(customer.specialTax)">Antes: {{ customer.specialTax.__old }}</span>
              <p v-if="isObject(customer.specialTax)"></p>
              <span>{{ isObject(customer.specialTax) ? customer.specialTax.__new : customer.specialTax }}</span>
            </div>
            <div class="two wide field">
              <label class="form-label">Varejo</label>
              <span v-if="isObject(customer.isRetail)">Antes: {{ customer.isRetail.__old ? 'Sim' : 'Não' }}</span>
              <p v-if="isObject(customer.isRetail)"></p>
              <span>{{ isObject(customer.isRetail) ? customer.isRetail.__new ? 'Sim' : 'Não' : customer.isRetail ? 'Sim' : 'Não' }}</span>
            </div>
          </div>
        </form>

      </div>

    </div>

  </div>

</template>

<script>

  import CustomerService from "@/services/customer-service"

  export default {
    
    props: ["customer"],    

    computed: {

      customerAddress() {
        return CustomerService.customerAddress(this.customer)        
      },
    },

    methods: {
      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    }
  }

</script>

